// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"845":"d9d34f346ebe9b60","3259":"e8359a14f88dae62","7125":"01cd8ba980bef64b"}[chunkId] + ".css";
};